"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.separatorMixin = exports.listBareMixin = void 0;
var _styledComponents = require("styled-components");
var _helpers = require("../helpers");
var _mixins = require("../mixins");
/*
 *@prettier
 */

var line = function line(props) {
  return (0, _styledComponents.css)(["content:\"\";display:block;width:calc( 100% - ", " - ", " );position:absolute;left:", ";height:1px;background-color:", ";", ""], (0, _mixins.getPaddingPropValue)(props, "left", "base"), (0, _mixins.getPaddingPropValue)(props, "right", "base"), (0, _mixins.getPaddingPropValue)(props, "left", "base"), (0, _helpers.getColor)(props, "separatorColor", "border"), props.separatorVariant === "full" && (0, _styledComponents.css)(["width:100%;left:0;"]));
};
var separatorMixin = function separatorMixin(props) {
  var placement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "bottom";
  return (0, _styledComponents.css)(["position:relative;&::after{", ";", ":0;}", ""], line(props), placement, placement === "both" && (0, _styledComponents.css)(["&::after{top:0;}&::before{", ";bottom:0;}"], line(props)));
};
exports.separatorMixin = separatorMixin;
var listBareMixin = (0, _styledComponents.css)(["margin:0;padding:0;list-style:none;"]);
exports.listBareMixin = listBareMixin;